import { Link } from 'react-router-dom';
import {motion} from 'motion/react';
import CDMorph from './landingAnimation.js'

/*
This will show 'MP3JUUG' in bolded letters
in the middle of the screen with a picture
of a CD morphing into an NFC card originally
with more mediums to be added to the animation
*/

function Landing(){
    return (
        <main className='hero'>
          <div className='hero-content'>
            <div className='hero-text'>
              <span className='hero-eyebrow'>DIY distribution</span>
              <motion.h1
                className='hero-title'
                initial={{ opacity: 0, y: 12 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, ease: 'easeOut' }}
              >
                From CD to music card.
              </motion.h1>
              <p className='hero-subtitle'>
                Upload your music, generate download links, and press them onto
                physical media — no label, no middleman, no .0003 per stream.
              </p>
              <nav className='hero-actions' aria-label='Get started'>
                <Link to='/upload' className='btn btn-primary'>Try now</Link>
                <Link to='/link' className='btn btn-secondary'>Download</Link>
              </nav>
            </div>

            <div className='hero-visual' aria-hidden='true'>
              <CDMorph/>
            </div>
          </div>

          <div className='hero-features'>
            <div className='hero-feature'>
              <h2>Upload</h2>
              <p>Drop your tracks and cover art — we handle the storage.</p>
            </div>
            <div className='hero-feature'>
              <h2>Distribute</h2>
              <p>Generate download links to share however you want.</p>
            </div>
            <div className='hero-feature'>
              <h2>Go physical</h2>
              <p>Place your links on CDs, NFC cards, or anything else.</p>
            </div>
          </div>
        </main>
    );

}

export default Landing;
